import { DEFAULT_TEMPLATE_ID, TemplateId } from '@cibli/shared';

import type { RegisteredTemplate } from './types';

// Registry of templates. New templates should be added here.
const templates = {} as Record<TemplateId, RegisteredTemplate<unknown>>;

export function registerTemplate<TParams extends Record<string, unknown>>(
  template: RegisteredTemplate<TParams>,
) {
  templates[template.meta.id] = template as unknown as RegisteredTemplate<unknown>;
}

export function getTemplate<TParams extends Record<string, unknown>>(
  id: TemplateId,
): RegisteredTemplate<TParams> {
  return (
    (templates[id] as unknown as RegisteredTemplate<TParams>) ??
    (templates[DEFAULT_TEMPLATE_ID] as unknown as RegisteredTemplate<TParams>)
  );
}

export function listTemplates() {
  return Object.values(templates).map(t => t.meta);
}
